import valid from 'card-validator'
import creditCardType from 'credit-card-type'
import { IntlShape } from 'react-intl'

export const creditCardFormSchema = {
  cardholderName: '',
  ccNumber: '',
  ccExpMonth: '',
  ccExpYear: '',
  ccCid: ''
}

export interface CreditCardFormValues {
  cardholderName: string
  ccNumber: string
  ccExpMonth: string
  ccExpYear: string
  ccCid: string
}

export const creditCardFormValidation = (intl: IntlShape) => (values: CreditCardFormValues) => {
  const { formatMessage } = intl
  const {
    cardholderName, ccNumber, ccExpMonth, ccExpYear, ccCid
  } = values
  const errors: Record<string, string> = {}
  const [card] = creditCardType(ccNumber)
  const cvvLength = card?.code?.size
  const numberValidation = valid.number(ccNumber)
  const monthValidation = valid.expirationMonth(ccExpMonth)
  const yearValidation = valid.expirationYear(ccExpYear)
  const cvvValidation = valid.cvv(ccCid, cvvLength)

  if (!numberValidation.isValid) {
    errors.ccNumber = formatMessage({ id: 'checkout.billing.ccForm.validation.numberValid' })
  }

  if (!monthValidation.isValid) {
    errors.ccExpMonth = formatMessage({ id: 'checkout.billing.ccForm.validation.expMonthValid' })
  }

  if (!yearValidation.isValid) {
    errors.ccExpYear = formatMessage({ id: 'checkout.billing.ccForm.validation.expYearValid' })
  }

  if (!cvvValidation.isValid) {
    errors.ccCid = formatMessage({ id: 'checkout.billing.ccForm.validation.cvvValid' })
  }

  if (!cardholderName || cardholderName.trim() === '') {
    errors.cardholderName = formatMessage({ id: 'checkout.billing.ccForm.validation.cardholderNameRequired' })
  }

  return errors
}
